import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "title_left" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = {
  key: 0,
  class: "badge"
}
const _hoisted_4 = { class: "title_right" }
const _hoisted_5 = { class: "text" }

import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { useRouter } from 'vue-router'

interface TProps {
  title: string
  badgeNum?: number
  skipPage: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CardTitle',
  props: {
    title: {},
    badgeNum: { default: -1 },
    skipPage: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "4cb5905e": (_unref(themeColor)),
  "449a950c": (_unref(themeColorWithAlpha))
}))

const props = __props

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.1)

const router = useRouter()
const skipPageHandle = () => {
  if (props.skipPage === '/task') {
    localStorage.removeItem('isCnDriverAppSource')
  }
  if (props.skipPage.startsWith('/broadcast')) { // 跳转资讯，需要传入Title
    router.push(props.skipPage + '&title=' + props.title)
  } else {
    router.push(props.skipPage)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card_title_container",
    onClick: skipPageHandle
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "dot" }, null, -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
      (_ctx.badgeNum !== -1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.badgeNum), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('app_more')), 1),
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "iconfont icon-icon_shouye_tiaozhuan" }, null, -1))
    ])
  ]))
}
}

})